import { FC } from 'react';

import BookADemo from '../book-a-demo';
import RoomstayBlogIncrease from '../roomstay-blog-increase/roomstay-blog-increase';
import RoomstaySemHelpdeskForm from '../roomstay-blog-sem-helpdesk-form/roomstay-blog-sem-helpdesk-form';

import styles from './roomstay-blog-footer-layout-2.module.scss';
import classNames from 'classnames';

export interface RoomstayFooterLayout2Props {
    theme?: 'default' | 'type-2';
    title?: string;
    description?: string;
    buttonText?: string;
    showMessage?: boolean;
    padding?: string;
    fontSizeTitle?: string;
    titleForm?: string;
    showTextFooter?: boolean;
    headlineFooter?: string;
    subHeadlineFooter?: string;
    buttonNameFooter?: string;
    buttonLinkFooter?: string;
    idSection?: string;
}

const RoomstayBlogFooterLayout2: FC<RoomstayFooterLayout2Props> = (props) => {
    const {
        theme,
        title,
        description,
        buttonText,
        titleForm,
        showMessage = true,
        padding = 'none',
        fontSizeTitle = 'small',
        showTextFooter,
        headlineFooter,
        subHeadlineFooter,
        buttonNameFooter,
        buttonLinkFooter,
        idSection,
    } = props;
    return (
        <div id={idSection} className="footer-book-a-demo-form-container">
            <div className="footer-book-a-demo-form--background-container">
                {theme !== 'type-2' && (
                    <svg className="background--curve" width="100%" height="100%" viewBox="0 0 1919 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M-1 50C-1 50 479 0 959 0C1439 0 1919 50 1919 50H-1Z" fill="#7C39FF" />
                    </svg>
                )}
                <div className="background--main"></div>
            </div>
            {showTextFooter ? (
                <div className={styles.wrapperText}>
                    <BookADemo headline={headlineFooter} subHeadline={subHeadlineFooter} buttonName={buttonNameFooter} buttonLink={buttonLinkFooter} />
                </div>
            ) : (
                <div className={classNames(styles.wrapper, theme === 'type-2' && styles.type2)}>
                    <div className={styles.increase}>
                        <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }}></h2>
                        <div className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }}></div>
                    </div>

                    <div className={styles.mail}>
                        <RoomstaySemHelpdeskForm titleForm={titleForm} fontSizeTitle={'small'} padding={'none'} buttonText={buttonText} showMessage={showMessage} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default RoomstayBlogFooterLayout2;
